import parse from 'url-parse';
import { sanitiseAssetName } from '@atlassian/jira-platform-sanitise-asset-name/src/index.js';

const isWRMResource = (url: string) => url.includes('/batch.js') || url.includes('/batch.css');
const getWRMAssetName = (url: string) => {
	const [, resources] = /\/([\w.\-,:]*?)(?:,-|\/batch\.)/.exec(url) || [];
	const assetName = sanitiseAssetName(process.env.NODE_ENV !== 'production')(url);

	if (!resources) {
		return assetName;
	}

	return `wrm/${resources}/${assetName}`;
};
const getFileName = (url: string) =>
	isWRMResource(url)
		? getWRMAssetName(url)
		: sanitiseAssetName(process.env.NODE_ENV !== 'production')(url);

const sanitiseEndpoints = (url: string) => {
	const parsedUrl = parse(url, true);

	/**
	 * For endpoints with operation or operationName queryParam we will shorten the url
	 * as ufo pipeline will only get the `operation` query param for aggregation
	 */
	const { operation, operationName } = parsedUrl.query;
	const operationNameOverride = operation ?? operationName;
	if (operationNameOverride) {
		return `/${operation}?operation=${operation}`;
	}

	const fileName = parsedUrl.pathname
		.replace(/\/(project|agent)(-config|s)?\/([A-Z0-9]+)/g, '/$1$2/<project-key>')
		.replace(/\/(servicedesk)(-data)?\/([A-Z0-9]+)/g, '/$1$2/<project-key>')
		.replace(
			/\/(browse|automation|pagination|permissions|async|dialog|itsm)\/([A-Z0-9]+)/g,
			'/$1/<project-key>',
		)
		.replace(/\/(board)(s)?\/([0-9]+)/g, '/$1$2/<board-id>')
		.replace(/\/(\w+)-(\d+)\//i, '/<issue-key>/')
		.replace(/\/pq\/[a-fA-F0-9]+/i, '/pq/<id>') // persisted queries
		.replace(/\/user\/[a-fA-F0-9\-:]+/i, '/user/<user-id>') // engage targeting
		.replace(
			/[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12}/i,
			'<uuid>',
		)
		.replace(/\/\d+$/i, '/<id>');

	return fileName;
};

export const jiraResourceTimingsConfig = {
	sanitiseEndpoints,
	mapResources: getFileName,
	hasTimingHeaders: (url: string) =>
		url.includes('jira-frontend-branch') ||
		url.includes('jira-frontend-bifrost') ||
		isWRMResource(url),
	// @ts-expect-error - TS7006 - Parameter 'url' implicitly has an 'any' type.
	xhrFilter: (url) => url.includes('/rest/greenhopper/'),
};
